// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3TbbX","label":"Labeled_label__mB9T2","divider":"Labeled_divider__5kbaR"};